/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Assistant_Delete_Chat_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "\"{title}\" will be permanently deleted from this device." |
*
* @param {Assistant_Delete_Chat_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_delete_chat_confirm_text = /** @type {((inputs: Assistant_Delete_Chat_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Delete_Chat_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`"${i?.title}" sera définitivement supprimé de cet appareil.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.title}" wird dauerhaft von diesem Gerät gelöscht.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`"${i?.title}" verrà eliminato definitivamente da questo dispositivo.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`"${i?.title}" будет безвозвратно удален с этого устройства.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`"${i?.title}" se eliminará permanentemente de este dispositivo.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`“${i?.title}”将从该设备中永久删除。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.title}」はこのデバイスから完全に削除されます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.title}" को इस डिवाइस से स्थायी रूप से हटा दिया जाएगा।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`"${i?.title}" será apagado permanentemente deste dispositivo.`)
	return /** @type {LocalizedString} */ (`"${i?.title}" will be permanently deleted from this device.`)
});